export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  image: string;
  author: string;
  publishDate: string;
  views: number;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const articles: Article[] = [
  {
    id: '1',
    slug: 'wanghong-douyin-dashen-tafang',
    title: '抖音千万粉丝网红深夜直播翻车，私下反差视频遭曝光，粉丝集体脱粉',
    excerpt: '拥有超过1200万粉丝的抖音头部网红在最新一场直播中因不当言论引发众怒，随后更有网友扒出其私下反差极大的视频内容，一时间舆论哗然。',
    content: '',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20composition%20with%20warm%20coral%20red%20and%20deep%20charcoal%20tones%2C%20featuring%20fragmented%20geometric%20shapes%20and%20soft%20glowing%20highlights%2C%20mysterious%20atmosphere%20with%20dark%20gradient%20background%2C%20modern%20editorial%20style%2C%20high%20contrast%2C%20clean%20minimal%20aesthetic%2C%20no%20text&width=800&height=600&seq=article-wanghong-2026-01&orientation=landscape',
    author: '吃瓜小编',
    publishDate: '2026-07-06',
    views: 285000,
    tags: ['抖音网红', '直播翻车', '反差视频', '塌房'],
    isHot: true,
    isNew: true,
  },
  {
    id: '2',
    slug: 'mingsu-nanxing-bagua',
    title: '知名男星深夜密会神秘女子，酒店同框照流出，工作室紧急回应',
    excerpt: '当红男星被拍到与神秘女子深夜同回酒店，两人举止亲密引发恋情猜测。工作室凌晨紧急发文澄清，却遭网友质疑避重就轻。',
    content: '',
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20composition%20with%20warm%20amber%20golden%20tones%20and%20mysterious%20shadow%20figures%2C%20soft%20blurred%20city%20night%20lights%2C%20cinematic%20atmosphere%2C%20modern%20editorial%20photography%20style%2C%20high%20contrast%2C%20clean%20minimal%20aesthetic%2C%20no%20text%20no%20people%20faces&width=800&height=600&seq=article-mingsu-2026-02&orientation=landscape',
    author: '八卦前线',
    publishDate: '2026-07-05',
    views: 192000,
    tags: ['男星', '恋情', '酒店', '工作室回应'],
    isHot: true,
    isNew: false,
  },
  {
    id: '3',
    slug: 'duli-baoliao-zhibojian-neimu',
    title: '独家爆料：某头部直播间数据造假实锤，后台截图流出震惊行业',
    excerpt: '据知情人士独家向本站爆料，某知名带货直播间存在大规模数据造假行为，后台真实数据与对外公布数据相差数十倍，涉及金额巨大。',
    content: '',
    category: '独家爆料',
    categorySlug: 'dujia-baoliao',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20composition%20with%20deep%20red%20and%20dark%20tones%2C%20digital%20data%20streams%20glowing%20in%20warm%20light%2C%20contrasting%20bright%20and%20dark%20elements%2C%20mysterious%20investigative%20atmosphere%2C%20modern%20editorial%20style%2C%20clean%20minimal%20aesthetic%2C%20no%20text&width=800&height=600&seq=article-duli-2026-03&orientation=landscape',
    author: '独家线人',
    publishDate: '2026-07-06',
    views: 356000,
    tags: ['直播间', '数据造假', '独家爆料', '行业黑幕'],
    isHot: true,
    isNew: true,
  },
  {
    id: '4',
    slug: 'zongyi-jiemu-zhengyi-jianji',
    title: '热门综艺剪辑引争议，选手现场原声曝光与播出内容大相径庭',
    excerpt: '近期热播选秀综艺因恶意剪辑再次登上热搜，多位参赛选手公开质疑节目组剪辑手法，称播出内容严重歪曲事实。',
    content: '',
    category: '综艺节目',
    categorySlug: 'zongyi-jiemu',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20composition%20with%20warm%20orange%20and%20coral%20tones%2C%20stage%20lighting%20effects%20and%20dramatic%20spotlight%2C%20theatrical%20atmosphere%20with%20soft%20gradients%2C%20modern%20editorial%20style%2C%20clean%20minimal%20aesthetic%2C%20no%20text%20no%20people&width=800&height=600&seq=article-zongyi-2026-04&orientation=landscape',
    author: '综艺观察员',
    publishDate: '2026-07-04',
    views: 167000,
    tags: ['综艺', '恶意剪辑', '选秀', '争议'],
    isHot: false,
    isNew: false,
  },
  {
    id: '5',
    slug: 'shehui-redian-gaokao-zuobi',
    title: '某地高考舞弊案细节曝光，多名考生家长涉嫌利益输送链浮出水面',
    excerpt: '教育部门联合公安部门披露一起重大考试舞弊案件，涉及利用高科技设备在高考中作弊，涉案人员已超过30人。',
    content: '',
    category: '社会热点',
    categorySlug: 'shehui-redian',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20composition%20with%20neutral%20warm%20taupe%20and%20cream%20tones%2C%20serious%20documentary%20atmosphere%2C%20soft%20architectural%20elements%2C%20clean%20minimal%20editorial%20style%2C%20high%20contrast%20shadows%2C%20no%20text%20no%20people&width=800&height=600&seq=article-shehui-2026-05&orientation=landscape',
    author: '社会观察',
    publishDate: '2026-07-03',
    views: 421000,
    tags: ['高考', '舞弊', '社会热点', '教育'],
    isHot: true,
    isNew: false,
  },
  {
    id: '6',
    slug: 'wanghong-kuaishou-jiaju',
    title: '快手大V被扒假装贫困博同情，私下奢华生活曝光打脸人设',
    excerpt: '一位以"农村励志故事"走红的快手大V被网友扒出其真实身份为富二代，所谓破旧老宅实为拍摄道具，反差之大令人咋舌。',
    content: '',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20composition%20with%20contrasting%20warm%20and%20dark%20tones%2C%20split%20screen%20aesthetic%2C%20luxury%20versus%20simplicity%20visual%20contrast%2C%20dramatic%20lighting%2C%20modern%20editorial%20style%2C%20clean%20minimal%20aesthetic%2C%20no%20text%20no%20people&width=800&height=600&seq=article-wanghong-2026-06&orientation=landscape',
    author: '吃瓜小编',
    publishDate: '2026-07-05',
    views: 238000,
    tags: ['快手', '人设崩塌', '假贫困', '富二代'],
    isHot: true,
    isNew: true,
  },
  {
    id: '7',
    slug: 'mingsu-nvxing-lihun-neimu',
    title: '知名女星离婚内幕曝光，财产分割协议细节流出，涉及数亿资产',
    excerpt: '娱乐圈又一对明星夫妻分道扬镳，据知情人透露，双方就财产分割问题争执数月，最终达成的协议涉及多处豪宅和公司股权。',
    content: '',
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20elegant%20composition%20with%20warm%20amber%20and%20soft%20cream%20tones%2C%20delicate%20fracture%20lines%20and%20separating%20shapes%2C%20emotional%20yet%20refined%20atmosphere%2C%20modern%20editorial%20style%2C%20clean%20minimal%20aesthetic%2C%20no%20text%20no%20people&width=800&height=600&seq=article-mingsu-2026-07&orientation=landscape',
    author: '八卦前线',
    publishDate: '2026-07-02',
    views: 312000,
    tags: ['女星', '离婚', '财产分割', '内幕'],
    isHot: true,
    isNew: false,
  },
  {
    id: '8',
    slug: 'duli-baoliao-yule-gongsi',
    title: '某娱乐公司内部聊天记录外泄，艺人黑料明码标价交易链曝光',
    excerpt: '一份疑似某头部娱乐公司内部工作群的聊天截图在网上疯传，内容涉及如何系统性地收集和交易艺人黑料，娱乐圈地下产业链浮出水面。',
    content: '',
    category: '独家爆料',
    categorySlug: 'dujia-baoliao',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20composition%20with%20deep%20crimson%20red%20and%20dark%20charcoal%20tones%2C%20digital%20chat%20bubble%20fragments%2C%20secretive%20atmosphere%2C%20modern%20editorial%20style%2C%20high%20contrast%2C%20clean%20minimal%20aesthetic%2C%20no%20text&width=800&height=600&seq=article-duli-2026-08&orientation=landscape',
    author: '独家线人',
    publishDate: '2026-07-06',
    views: 489000,
    tags: ['娱乐公司', '聊天记录', '黑料交易', '产业链'],
    isHot: true,
    isNew: true,
  },
  {
    id: '9',
    slug: 'zhibo-fanche-daihuo-jiahuo',
    title: '头部主播直播带货翻车，所售品牌被曝为贴牌假货，消费者集体维权',
    excerpt: '拥有数千万粉丝的带货主播在直播中推荐的某护肤品品牌被消费者举报为贴牌假货，目前已有数百名消费者联合发起维权。',
    content: '',
    category: '直播翻车',
    categorySlug: 'zhibo-fanche',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20composition%20with%20warm%20orange%20and%20coral%20red%20tones%2C%20shopping%20cart%20and%20packaging%20fragments%2C%20consumer%20warning%20atmosphere%2C%20dramatic%20lighting%2C%20modern%20editorial%20style%2C%20clean%20minimal%20aesthetic%2C%20no%20text&width=800&height=600&seq=article-zhibo-2026-09&orientation=landscape',
    author: '消费维权',
    publishDate: '2026-07-04',
    views: 275000,
    tags: ['直播带货', '假货', '维权', '翻车'],
    isHot: true,
    isNew: false,
  },
  {
    id: '10',
    slug: 'shehui-redian-xiaoyuan-baoli',
    title: '某地校园霸凌视频网络疯传，教育局紧急介入调查，涉事学校回应',
    excerpt: '一段显示多名学生对一名同学实施霸凌的视频在社交平台迅速传播，引发社会各界强烈关注，当地教育局已成立专项调查组。',
    content: '',
    category: '社会热点',
    categorySlug: 'shehui-redian',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20composition%20with%20muted%20warm%20taupe%20and%20deep%20charcoal%20tones%2C%20school%20corridor%20silhouettes%2C%20serious%20documentary%20atmosphere%2C%20soft%20dramatic%20lighting%2C%20modern%20editorial%20style%2C%20clean%20minimal%20aesthetic%2C%20no%20text%20no%20people&width=800&height=600&seq=article-shehui-2026-10&orientation=landscape',
    author: '社会观察',
    publishDate: '2026-07-01',
    views: 534000,
    tags: ['校园霸凌', '教育局', '社会热点', '视频'],
    isHot: false,
    isNew: false,
  },
  {
    id: '11',
    slug: 'wanghong-bilibili-upzhu',
    title: 'B站百万UP主被扒学历造假，人设崩塌后紧急删视频并关闭评论区',
    excerpt: '一位以"名校学霸"人设走红的B站UP主被网友扒出学历造假，其自称的海外名校背景纯属虚构，大量粉丝表示失望。',
    content: '',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20composition%20with%20warm%20coral%20and%20dark%20academic%20tones%2C%20diploma%20fragments%20and%20digital%20screens%2C%20revelation%20atmosphere%2C%20modern%20editorial%20style%2C%20high%20contrast%2C%20clean%20minimal%20aesthetic%2C%20no%20text&width=800&height=600&seq=article-wanghong-2026-11&orientation=landscape',
    author: '吃瓜小编',
    publishDate: '2026-07-06',
    views: 198000,
    tags: ['B站', 'UP主', '学历造假', '人设崩塌'],
    isHot: false,
    isNew: true,
  },
  {
    id: '12',
    slug: 'zongyi-jiemu-pingwei-zhengyi',
    title: '选秀节目评委言论引发争议，现场观众爆料评委存在明显偏向',
    excerpt: '某热门选秀节目中，一位评委对选手的不当评价引发观众不满，现场观众更爆料该评委对特定选手存在明显偏袒行为。',
    content: '',
    category: '综艺节目',
    categorySlug: 'zongyi-jiemu',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20composition%20with%20warm%20amber%20and%20theatrical%20spotlight%20tones%2C%20stage%20and%20audience%20silhouettes%2C%20dramatic%20performance%20atmosphere%2C%20modern%20editorial%20style%2C%20clean%20minimal%20aesthetic%2C%20no%20text%20no%20people&width=800&height=600&seq=article-zongyi-2026-12&orientation=landscape',
    author: '综艺观察员',
    publishDate: '2026-07-03',
    views: 143000,
    tags: ['选秀', '评委', '争议', '偏袒'],
    isHot: false,
    isNew: false,
  },
];